import { render } from "./IOSInstallBanner.vue?vue&type=template&id=3d2cb5c6&scoped=true"
import script from "./IOSInstallBanner.vue?vue&type=script&lang=js"
export * from "./IOSInstallBanner.vue?vue&type=script&lang=js"

import "./IOSInstallBanner.vue?vue&type=style&index=0&id=3d2cb5c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2cb5c6"]])

export default __exports__